import styled from 'styled-components';
import { theme } from './CardTheme';

/** @deprecated use @cld/paper instead */
export const BaseCard = styled.div`
  position: relative;
  outline: none;
  transition: background-color 250ms;
  background-color: ${theme.background.color.base};
  color: ${theme.font.color.base};
  border-radius: ${theme.border.radius};
`;
